import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ai-product_content flex-column align-center" }
const _hoisted_2 = {
  key: 0,
  class: "generate-content"
}
const _hoisted_3 = { class: "generate-content_content" }

import { alertController, IonInput, IonPage, modalController } from "@ionic/vue"

import aiLoading from "@/components/aiLoading.vue";
import { aiUsageLimit } from "@/js/aiUsageLimit";
import { useRouter } from "vue-router"
import { nextTick, onMounted, reactive, ref, watch } from "vue"
import tools from "@/js/tools"
import requestApi from "@/js/http"
import http from "@/js/http"
import { BRAND_IMAGES } from "@/js/brandImages"
import WinRecord from "@/js/Record"
import store from "@/js/store"
import PageWhiteBackground from "@/components/PageWhiteBackground.vue"
import { useStorage, useToggle } from "@vueuse/core"
import TextDictionary from "@/views/AIGenerate/components/TextDictionary.vue"
import mqttServer from "@/js/mqtt"

const audio_url = "http://47.254.121.216:6039/api/speechMsg";
const audio_file_url = "http://47.254.121.216:6039/";
const authorization =
  "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOiJzeXNfdXNlcjoxNzM3NjY0OTMyNDI2MTU4MDgxIiwicm5TdHIiOiJOMlFWMnNDdzh2TmdQSllVNFRheUlFeWdyVUtHb0lBZCIsInRlbmFudElkIjoiMDAwMDAiLCJ1c2VySWQiOjE3Mzc2NjQ5MzI0MjYxNTgwODF9.YExs672d7euNs27Xsl5aum5433AJEMYum9fpOYdC3zA"

interface Props {
  word?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AIGenerate',
  props: {
    word: {}
  },
  setup(__props: any) {

const server_url = `${http.aiUrl}/gpt/sseChatPrompt`
const record = ref<any>(null);
const userInfo = useStorage("userinfo", {});
const aiLoadingRef = ref();
const router = useRouter();
const params = ref<any>();
const textComponent2 = ref<any>();
const markdownRef = ref<any>();
const props = __props;
const [isLoading, changeIsLoading] = useToggle();
const brandImages = BRAND_IMAGES;
const baseData = reactive<any>({
  title: "",
  // 选择题
  testPaperData: [],
  // 问答题
  questionsAndAnswersData: {},
  questionsAnswersResData: "",
  // 完形填空
  clozeData: {},
  question: "",
  aiType: "",
  audioUrl: "",
  audioPlayState: true,
  audioFile: null,
  markdownDom: null,
  conversationId: "", // chatGpt会话id
})

const httpController = ref<any>()
const instructData = {
  project: "lxll",
  page: "teachIndex",
  module: "AlGenerate",
  userType: 1,
  data: null,
  fn: "",
  param: null,
  timestamp: " ",
}

/**
 * 【AI词典大全】 OPENAI_PROMPT_WORDLIST
 * 【AI语法分析】OPENAI_PROMPT_ANALYZEGRAMAR
 * 【AI校对文章】 OPENAI_PROMPT_PROOFREAD_ARTICLE
 * 【AI短文】（1）OPENAI_PROMPT_READPASSAGE （2） OPENAI_PROMPT_READPASSAGE_V1 新
 * 【AI对话练习】 OPENAI_PROMPT_VOICE_CONVERSATION
 * 【AI阅读理解】 OPENAI_PROMPT_EXAMPAPER_QA
 * 【AI短句训练】 OPENAI_PROMPT_SHORT_SENTENCE
 */

async function routerBack() {
  if (textComponent2.value) {
    textComponent2.value.pauseAudio();
  }
  nextTick(() => {
    baseData.questionsAnswersResData = "";
    httpController.value?.abort("终止请求"); // 终止请求
  });
  mqttServer
    .pushMsg(instructData, {
      fn: "closeModal",
      msgType: "function",
    })
    .then(async () => {
      closeModal()
    })
  textComponent2.value.pauseAudio()
}
async function closeModal() {
  await modalController.dismiss()
}

// 处理消息
async function onMessageReceived(msg: any) {
  if (msg.fn === "closeModal") {
    await closeModal()
  }
}

// 请求gpt
async function postChatMessage(word: string) {
  baseData.questionsAnswersResData = "";
  httpController.value?.abort("终止请求");
  changeIsLoading(true);
  if (aiLoadingRef.value) {
    aiLoadingRef.value.open();
  }
  const serverKey = "OPENAI_PROMPT_WORDLIST-0510";
  const requestParams = {
    userSubmitId: userInfo.value?.schoolId,
    userKey: "",
    serverKey: serverKey,
    conversationId: new Date().getTime(),
    prompt: word.trim() || "", // baseData.question
    promptParameter: { grade: "", wordCount: "" },
    options: {},
    usingContext: true,
    topP: 1,
    contentNumber: 10,
    filterSensitive: true,
  };
  try {
    const usageLimit = await aiUsageLimit(serverKey);
    if (usageLimit) {
      const resData = await http.post("/ai/dict", requestParams);
      if (resData.data.code == 200) {
        baseData.questionsAnswersResData = { 单词: baseData.question, ...resData.data.data };
      } else {
        baseData.questionsAnswersResData;
      }
      aiLoadingRef.value && aiLoadingRef.value.close();
    } else {
      aiLoadingRef.value && aiLoadingRef.value.close();
    }
    changeIsLoading(false);
  } catch (e) {
    changeIsLoading(false);
    aiLoadingRef.value && aiLoadingRef.value.close();
  }
}

function getMarkdownCallback(callback: any) {
  callback(baseData.question)
}

// 根据返回接口生成音频文件并播放
function getAudioUrl(signal: any) {
  if (baseData.audioFile) {
    baseData.audioFile.pause()
    baseData.audioFile = null
  }
  baseData.audioUrl = ""
  const conversationParams = {
    msgId: new Date().getTime(),
    msg: baseData.question,
    signal: signal,
  }
  requestApi.post(audio_url, conversationParams).then((res) => {
    if (res?.data?.code === 200) {
      baseData.audioUrl = audio_file_url + res.data.msg || ""
      baseData.audioFile = new Audio(baseData.audioUrl) as any

      // 获取音频文件立即播放
      if (baseData.audioFile) {
        baseData.audioFile.play()
        baseData.audioPlayState = false
      }
      handleAudioEndEvent()
    }
  })
}

// 点击播放 or 暂停播放
async function audioPlay() {
  if (baseData.audioFile) {
    // load() 重新加载
    // 播放
    if (baseData.audioPlayState) {
      baseData.audioFile.play()
      baseData.audioPlayState = false
    } else {
      // 停止播放
      baseData.audioFile.pause()
      baseData.audioPlayState = true
    }
  } else {
    alertPopOverDialog("暂无音频文件，请稍等...")
  }
}

// 监听音频文件播放结束
function handleAudioEndEvent() {
  if (baseData.audioFile) {
    baseData.audioFile.addEventListener("ended", () => {
      baseData.audioPlayState = true
    })
  }
}

// 弹窗组件
async function alertPopOverDialog(msg: string) {
  const alert = await alertController.create({
    subHeader: msg,
    buttons: [],
  })
  await alert.present()
}

// 下拉刷新页面
function doRefresh(RefreshAnimationEvent: any) {
  tools.closeRefreshAnimation(RefreshAnimationEvent, 200)
}

// 点击页面返回按钮 返回首页
function navigateBackHomePage() {
  router.back()
  // router.push('/TeacherIndex')
  // 音频文件停止播放
  if (baseData.audioFile) {
    baseData.audioFile.pause()
    baseData.audioFile = null
    baseData.audioPlayState = true
  }

  nextTick(() => {
    baseData.questionsAnswersResData = ""
    httpController.value?.abort("终止请求") // 终止请求
  })
}

function getHttpControllerSignal() {
  httpController.value = new AbortController()
  const { signal } = httpController.value
  return signal
}

function getAudioGptAnswer(rData: string) {
  const signal = getHttpControllerSignal()
  baseData.question = rData ? rData?.data : ""
  // baseData.question = 'What day is it today'
  getAudioUrl(signal)
}

function initRecord() {
  const isMobile = store.isMobile()

  // 判断是否是手机端
  if (isMobile) {
    // record.value = new Record() // 手机 html5 录音
    record.value = new WinRecord(audio_file_url)
  } else {
    record.value = new WinRecord(audio_file_url)
  }
}

function handleStop() {
  httpController.value?.abort()
}

function handleWindowLocationParamsValue() {
  const pathname = window.location.pathname
  const regex = /^\/ai-generate\/(.*)$/
  const match = pathname.match(regex)
  if (match) {
    params.value = match[1]
  }
}

watch(
  () => props.word,
  () => {
    if (props.word) {
      postChatMessage(props.word);
      baseData.question = props.word;
    }
  },
  { immediate: true }
)
onMounted(() => {
  handleWindowLocationParamsValue();
  initRecord();
  handleAudioEndEvent();
  baseData.markdownDom = document.querySelector(".markdown-body2") as any;
  if (aiLoadingRef.value) {
    aiLoadingRef.value.open();
  }
  mqttServer.onMqttMessage(instructData.module, onMessageReceived)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), { class: "ai-product" }, {
    default: _withCtx(() => [
      _createElementVNode("div", { class: "ai-product_header" }, [
        _createElementVNode("div", { class: "ai-product_header-icon" }, [
          _createElementVNode("i", {
            class: "iconfont icon-back",
            onClick: routerBack
          })
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "ai-product_header-title" }, "AI词典", -1)),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "ai-product_header-icon" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_1, [
        (params.value !== 'dialogue' && params.value !== 'voiceConversation')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(TextDictionary, {
                  ref_key: "textComponent2",
                  ref: textComponent2,
                  "generate-type": "vocabulary",
                  "as-raw-text": false,
                  inversion: false,
                  text: baseData.questionsAnswersResData,
                  "prop-word": baseData.question,
                  loading: _unref(isLoading),
                  onGetMarkdownCallback: getMarkdownCallback
                }, null, 8, ["text", "prop-word", "loading"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(aiLoading, {
        ref_key: "aiLoadingRef",
        ref: aiLoadingRef
      }, null, 512)
    ]),
    _: 1
  }))
}
}

})